import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "footer dark-bar",
  id: "contact"
}
const _hoisted_2 = { class: "container content-section" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "title text-center" }, "Let's get in touch", -1)
const _hoisted_4 = { class: "flex-container" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "copyright" }, [
  /*#__PURE__*/_createVNode("a", {
    target: "_blank",
    href: "/pdf/Nederland_ICT_Voorwaarden.pdf",
    style: {"color":"inherit"}
  }, "Nederland ICT Voorwaarden"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" © copyright 2010-2021 mobilem B.V. All rights reserved ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactForm = _resolveComponent("ContactForm")
  const _component_Map = _resolveComponent("Map")

  return (_openBlock(), _createBlock("footer", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_ContactForm),
        _createVNode(_component_Map)
      ]),
      _hoisted_5,
      _hoisted_6
    ])
  ]))
}